import React from 'react';
import styled from 'styled-components';
import type { MessageThreadDetail } from '../../../../lib/api';
import { MessageList } from '../MessageList';

interface HistoryViewProps {
  threads: MessageThreadDetail[];
  patientId: number | null;
  error: Error | null;
}

const Container = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: ${({ theme }) => theme.spacing.md};
  background-color: #F5F5F5;
`;

const CenterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: ${({ theme }) => theme.spacing.xl};
  text-align: center;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

const EmptyImage = styled.img`
  width: 120px;
  height: auto;
  margin-bottom: ${({ theme }) => theme.spacing.lg};
  opacity: 0.6;
`;

const EmptyTitle = styled.p`
  font-size: ${({ theme }) => theme.typography.fontSize.lg};
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
  color: ${({ theme }) => theme.colors.text.secondary};
  margin: 0 0 ${({ theme }) => theme.spacing.sm} 0;
`;

const EmptyDescription = styled.p`
  font-size: ${({ theme }) => theme.typography.fontSize.md};
  color: ${({ theme }) => theme.colors.text.muted};
  margin: 0;
`;

const EmptyText = styled.p`
  font-size: ${({ theme }) => theme.typography.fontSize.md};
  margin: 0;
  line-height: 1.6;
`;

/**
 * メッセージ履歴の表示。
 * ローディングは親（MessagePage）の PageDataBoundary が担うため、ここでは扱わない。
 */
export const HistoryView: React.FC<HistoryViewProps> = ({
  threads,
  patientId,
  error,
}) => {
  if (error) {
    return (
      <CenterContainer>
        <EmptyText>
          メッセージの読み込みに失敗しました。
          <br />
          しばらくしてから再度お試しください。
        </EmptyText>
      </CenterContainer>
    );
  }

  if (threads.length === 0) {
    return (
      <CenterContainer>
        <EmptyImage src="/images/empty-mailbox.png" alt="やりとりはありません" />
        <EmptyTitle>やりとりはありません</EmptyTitle>
        <EmptyDescription>連絡するとやりとりが表示されます。</EmptyDescription>
      </CenterContainer>
    );
  }

  return (
    <Container>
      <MessageList threads={threads} patientId={patientId} />
    </Container>
  );
};

export default HistoryView;
